// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_mI1","cls2":"CoauthorConfirmationCard-cls2_Ftt CoauthorConfirmationCard-cls1_mI1"};